import { NavLink, useNavigate } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';
import { pushModal, removeModal } from '../utils/modalStack';

export default function BottomNav() {
  const navigate = useNavigate();
  const [showJoin, setShowJoin] = useState(false);
  const [code, setCode] = useState('');

  // closeJoin removes itself from the modal stack (so back button doesn't re-trigger),
  // then closes the sheet. When the back button calls popModal() it invokes this directly
  // without going through removeModal first — that's fine because removeModal is a no-op
  // when the entry is already gone.
  const closeJoin = useCallback(() => {
    removeModal(closeJoin);
    setShowJoin(false);
    setCode('');
  }, []);

  useEffect(() => {
    if (showJoin) pushModal(closeJoin);
  }, [showJoin, closeJoin]);

  const handleJoin = () => {
    if (code.trim()) {
      navigate(`/vaquita/preview/${code.trim()}`);
      closeJoin();
      setCode('');
    }
  };

  return (
    <>
      {showJoin && (
        <div className="join-overlay" onClick={() => closeJoin()}>
          <div className="join-sheet" onClick={e => e.stopPropagation()}>
            <div className="join-handle" />
            <h3>Unirse a vaquita</h3>
            <input
              className="join-input"
              type="text"
              placeholder="Código de invitación"
              value={code}
              onChange={e => setCode(e.target.value.toUpperCase())}
              onKeyDown={e => e.key === 'Enter' && handleJoin()}
              autoFocus
            />
            <button className="join-btn" onClick={handleJoin}>Unirme</button>
          </div>
        </div>
      )}

      <nav className="bottom-nav">
        <NavLink to="/home" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <span className="nav-icon">🏠</span>
          <span className="nav-label">Inicio</span>
        </NavLink>
        <button className="nav-item" onClick={() => setShowJoin(true)}>
          <span className="nav-icon">🔗</span>
          <span className="nav-label">Unirse</span>
        </button>
        <NavLink to="/my-vaquitas" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <span className="nav-icon">🐮</span>
          <span className="nav-label">Vaquitas</span>
        </NavLink>
        <NavLink to="/friends" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <span className="nav-icon">👥</span>
          <span className="nav-label">Amigos</span>
        </NavLink>
        <NavLink to="/profile" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <span className="nav-icon">👤</span>
          <span className="nav-label">Perfil</span>
        </NavLink>
      </nav>

      <style jsx>{`
        .bottom-nav {
          display: none;
        }

        @media (max-width: 768px) {
          .bottom-nav {
            display: flex;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            height: 64px;
            background: var(--bg-secondary);
            border-top: 1px solid var(--border-color);
            z-index: 999;
            box-shadow: 0 -2px 12px var(--shadow-color);
            padding: 0 0.25rem;
            padding-bottom: env(safe-area-inset-bottom);
          }
        }

        .nav-item {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 2px;
          text-decoration: none;
          color: var(--text-muted);
          background: none;
          border: none;
          cursor: pointer;
          padding: 0.5rem 0;
          transition: color 0.15s;
          font-size: inherit;
          -webkit-tap-highlight-color: transparent;
        }

        .nav-item.active {
          color: var(--accent-color);
        }

        .nav-icon {
          font-size: 1.4rem;
          line-height: 1;
        }

        .nav-label {
          font-size: 0.65rem;
          font-weight: 500;
          letter-spacing: 0.02em;
        }

        /* Join sheet */
        .join-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.5);
          z-index: 1100;
          display: flex;
          align-items: flex-end;
        }

        .join-sheet {
          background: var(--bg-secondary);
          border-radius: 20px 20px 0 0;
          padding: 1rem 1.5rem 2rem;
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .join-handle {
          width: 40px;
          height: 4px;
          background: var(--border-color);
          border-radius: 2px;
          margin: 0 auto;
        }

        .join-sheet h3 {
          margin: 0;
          color: var(--text-primary);
          font-size: 1.1rem;
        }

        .join-input {
          padding: 0.9rem 1rem;
          border: 1.5px solid var(--border-color);
          border-radius: 10px;
          font-size: 1.1rem;
          background: var(--bg-primary);
          color: var(--text-primary);
          text-transform: uppercase;
          letter-spacing: 0.1em;
        }

        .join-input:focus {
          outline: none;
          border-color: var(--accent-color);
        }

        .join-btn {
          padding: 0.9rem;
          background: var(--accent-color);
          color: white;
          border: none;
          border-radius: 10px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
        }
      `}</style>
    </>
  );
}
